import type { infer as zInfer } from "zod";
import { object, string } from "zod";

export const getBlueCherryIntegration = {
  name: "getBlueCherryIntegration" as const,
  input: object({}),
  output: object({
    blueCherryIntegration: object({
      companyCode: string(),
      environmentCode: string(),
    }).optional(),
  }),
};

export type BlueCherryIntegration = zInfer<
  typeof getBlueCherryIntegration.output
>;
